(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // --- Mobile Menu Script ---
  // This script handles the opening and closing of the mobile navigation menu in the header.
  // It ensures the menu opens on button click, closes when clicking outside, and does not close when clicking inside the menu.
  document.addEventListener('DOMContentLoaded', () => {
    // Get the mobile menu toggle button and the menu panel
    const mobileMenuButton = document.querySelector('[data-action="toggle-mobile-menu"]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');

    if (mobileMenuButton && mobileMenu) {
      // Function to close the mobile menu by adding the 'hide' class
      const closeMenu = () => {
        mobileMenu.classList.add('hide');
      };

      // Toggle menu on button click
      // If menu is hidden, show it; otherwise, close it
      mobileMenuButton.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent click from bubbling to document
        if (mobileMenu.classList.contains('hide')) {
          mobileMenu.classList.remove('hide');
        } else {
          closeMenu();
        }
      });

      // Close menu when clicking outside the menu or button
      document.addEventListener('click', (e) => {
        if (
          !mobileMenu.classList.contains('hide') && // Menu is open
          !mobileMenu.contains(e.target) && // Click not inside menu
          !mobileMenuButton.contains(e.target) // Click not on button
        ) {
          closeMenu();
        }
      });

      // Prevent clicks inside the menu from closing it
      mobileMenu.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  });
  // --- End Mobile Menu Script ---

  } catch(e) { console.error(e); }
})();
})();
